import { render, staticRenderFns } from "./LiveRoomType.vue?vue&type=template&id=a585a744&"
import script from "./LiveRoomType.vue?vue&type=script&lang=js&"
export * from "./LiveRoomType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports